import { Role, rolesManipulator } from 'auth';
import { Button, TextInputField } from 'ui';
import { usePrint } from 'ui/hooks';
import { EditGrayIcon, PrintGrayIcon } from 'ui/icons';

interface FormResultsModalTitleProps {
  editing: boolean;
  name: string;
  disableTitleEditing?: boolean;
  onTurnOnEditing: () => void;
  onPrint?: () => void;
  discardButton: {
    onClick: () => void;
    disabled: boolean;
  };
  submitButton: {
    onClick: () => void;
    disabled: boolean;
  };
  showPrint?: boolean;
  allowPrintForNonAdmin?: boolean;
}

const FormResultsModalTitle = ({
  editing,
  name,
  submitButton,
  discardButton,
  onTurnOnEditing,
  onPrint,
  disableTitleEditing,
  showPrint,
  allowPrintForNonAdmin = false,
}: FormResultsModalTitleProps) => {
  const { print } = usePrint();
  const isUserAdmin = rolesManipulator.current_user_role === Role.COMPLIANCE_ADMIN;
  const canPrint = showPrint && (isUserAdmin || allowPrintForNonAdmin);
  const handlePrint = onPrint || print;

  return (
    <div className="flex justify-between gap-1">
      <div className="truncate max-w-[490px]" title={editing ? undefined : name}>
        {editing && !disableTitleEditing ? (
          <TextInputField name="incident.name" className="min-h-8 text-[24px] !p-0" />
        ) : (
          name
        )}
      </div>
      {!editing && (canPrint || isUserAdmin) && (
        <div className="flex gap-3 items-center select-none">
          {canPrint && (
            <span onClick={handlePrint} className="hover:opacity-80 cursor-pointer">
              <img src={PrintGrayIcon} alt="Print" className="w-6 h-6 min-w-6 min-h-6" />
            </span>
          )}
          {isUserAdmin && (
            <span onClick={onTurnOnEditing} className="hover:opacity-80 cursor-pointer">
              <img src={EditGrayIcon} alt="edit" className="w-6 h-6 min-w-6 min-h-6" />
            </span>
          )}
        </div>
      )}
      {isUserAdmin && editing && (
        <div className="flex gap-3 shrink-0 font-[Inter]">
          <Button
            className="w-fit py-0 min-h-8"
            variant="secondary"
            type={'button'}
            onClick={discardButton.onClick}
            disabled={discardButton.disabled}
          >
            Discard
          </Button>
          <Button
            type={'submit'}
            className="w-fit py-0 min-h-8"
            onClick={submitButton.onClick}
            disabled={submitButton.disabled}
          >
            Save changes
          </Button>
        </div>
      )}
    </div>
  );
};

export default FormResultsModalTitle;
